const sysdenunciaConfig = {
    apiUrl: 'https://portaldenuncias.trigenius.pt',
};

export default sysdenunciaConfig;